import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from 'react-tooltip';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

const TextInput = ({ label, name, register, errors, required, stackLayout = false, readOnly, prefix, suffix, onSuffixClick, styles = {}, showErrorIcon = false, labelCol, inputCol, ...rest }) => {
    if (stackLayout) {
        return (
            <div className={label ? "mb-3" : "mb-0"}>
                {label && <label className="form-label">{label} {required && <span className="text-danger">*</span>}</label>}
                <div className="position-relative">
                    {prefix && (
                        <span className="text-input-prefix">
                            {prefix}
                        </span>
                    )}
                    <input
                        type="text"
                        className={`form-control ${errors?.[name] ? "is-invalid" : ""}`}
                        {...register(name)}
                        readOnly={readOnly}
                        style={{
                            backgroundImage: 'none',
                            paddingRight: suffix ? '2.5rem' : '0.75rem',
                            paddingLeft: prefix ? '2.5rem' : '0.75rem',
                            ...(readOnly ? { backgroundColor: '#e9ecef', cursor: 'not-allowed' } : {}),
                            ...styles
                        }}
                        {...rest}
                    />
                    {suffix && (
                        <button
                            type="button"
                            className="text-input-suffix"
                            onClick={onSuffixClick}
                            tabIndex="-1"
                        >
                            {suffix}
                        </button>
                    )}
                    {showErrorIcon && errors?.[name] && (
                        <span
                            className="ml-2"
                            style={{
                                position: 'absolute',
                                right: (() => {
                                    if (rest.type === 'number') return suffix ? '3.2rem' : '1.5rem';
                                    return suffix ? '2.5rem' : '0.75rem';
                                })(),
                                top: '50%',
                                transform: 'translateY(-50%)',
                                zIndex: 2
                            }}
                        >
                            <FontAwesomeIcon
                                icon={faCircleInfo}
                                className="text-danger"
                                data-tooltip-id={`tooltip-${name}`}
                                style={{ cursor: 'pointer' }}
                            />
                            <Tooltip 
                                id={`tooltip-${name}`} 
                                place="top" 
                                effect="solid"
                                delayShow={50}
                                delayHide={0}
                                clickable={false}
                                openOnClick={false}
                                events={['hover']}
                            >
                                {errors[name].message}
                            </Tooltip>
                        </span>
                    )}
                    {!showErrorIcon && errors?.[name] && <div className="stack invalid-feedback">{errors[name].message}</div>}
                </div>
            </div>
        );
    }

    return (
        <div className="row mb-4">
            <div className={`col-${labelCol ? labelCol : '4' }`}>
                <label className="form-label mb-0">{label} {required && <span className="text-danger">*</span>}</label>
            </div>
            <div className={`col-${inputCol ? inputCol : '8'} position-relative`}>
                {prefix && (
                    <span className="text-input-prefix">
                        {prefix}
                    </span>
                )}
                <input
                    type="text"
                    className={`form-control ${errors?.[name] ? "is-invalid" : ""}`}
                    {...register(name)}
                    readOnly={readOnly}
                    style={{
                        backgroundImage: 'none',
                        paddingRight: suffix ? '2.2rem' : '0.75rem',
                        paddingLeft: prefix ? '2.2rem' : '0.75rem',
                        ...(readOnly ? { backgroundColor: '#e9ecef', cursor: 'not-allowed' } : {})
                    }}
                    {...rest}
                />
                {suffix && (
                    <button
                        type="button"
                        className="text-input-suffix"
                        onClick={onSuffixClick}
                        tabIndex="-1"
                    >
                        {suffix}
                    </button>
                )}
                {errors?.[name] && <div className="invalid-feedback mt-2">{errors[name].message}</div>}
            </div>
        </div>
    );
};

export default TextInput;
